/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'items': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 0v3.23h2V0H0zM0 5.385v3.23h2v-3.23H0zM0 10.77V14h2v-3.23H0zM4 1.077v1.077h10V1.077H4zM4 6.462v1.076h10V6.462H4zM4 11.846v1.077h10v-1.077H4z" _fill="#fff"/>'
  }
})
